// extracted by mini-css-extract-plugin
export var printerCard = "_hp-1";
export var printerCardConfigured = "_hp-2";
export var printerCardError = "_hp-3";
export var printerCardsContainer = "_hp-0";
export var printerIcon = "_hp-8";
export var printerIconConfigured = "_hp-5";
export var printerIconContainer = "_hp-4";
export var printerIconError = "_hp-6";
export var printerIconUnconfigured = "_hp-7";
export var workstationsTableCard = "_hp-9";